export default "__VITE_ASSET__M5ilmS2X__"